import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
import label from "../labels/recommendationProcess_en.json";
import InterviewReportApprovalEntity from "../../../src/recommendationProcess/components/InterviewReportApprovalEntity";
import TablePagination from "../../common/components/TablePagination";
import commonLabels from "../../common/labels/common_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
} from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getInterviewMarkStatementByExamId, interviewMarksApprovalRequest, getAllApprovalInterviewMarksPagination } from "../actions/recommendationProcessActions";
import { getYearList, getMainsAdvertisements } from "../../common/actions/commonActions";

import ImportInterviewMarks from "../../interviewProcess/components/interviewSchedule/ImportInterviewMarks";

let headerField = [
  {
    id: "1",
    steps: "Step 1",
    name: "Approvals",
  },
  {
    id: "2",
    steps: "Step 2",
    name: "Interview Marks",
  },
];

const InterviewReport = () => {

  const pdfRef = useRef(null);

  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    // "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];

  const { register, handleSubmit, errors } = useForm(
    {
      mode: "onChange",
    }
  );

  let { interviewMarkStatement } = useSelector(
    (state) => state.recommendationProcessReducer,
    shallowEqual
  );

  let { advertisementList, examList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );


  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let {
    allUnapprovalEntityList,
    unapprovalPageNoCounter,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);


  let tableCounter_unapproval = unapprovalPageNoCounter + 1;
  let rowPerPage = 10;

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");
  const [stepName, setName] = useState("2");
  // const [editedValues, setEditedValues] = useState({});
  const [editedValues, setEditedValues] = useState({
    interviewMarkStatement: []
  });
  const [editMode, setEditMode] = useState(false);
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);

  const [interviewMarksData, setInterviewMarksData] = useState([]);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [showImportMarks, setShowImportMarks] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getYearList());
    onCancelButton();
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (stepName === "1") {
      dispatch(
        getAllApprovalInterviewMarksPagination(listCurrentPage, rowPerPage)
      );
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    if (interviewMarkStatement.interviewMarkStatement) {
      setInterviewMarksData(interviewMarkStatement.interviewMarkStatement);
    }
  }, [interviewMarkStatement.interviewMarkStatement, setInterviewMarksData]);

  useEffect(() => {
    setPrintFlag(interviewMarksData.length === 0);
  }, [interviewMarksData]);

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    examList.length = 0;
    setInterviewMarksData([]);
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    setSaveButtonFlag(false);
    setConfirmClicked(true);
    setPrintFlag(true);
    selectedValue && dispatch(getInterviewMarkStatementByExamId(selectedValue));
    setReloadItem(!reloadItem);
    setInterviewMarksData([]);
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedYear("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    setReloadItem(!reloadItem);
    examList.length = 0;
    getMainsAdvertisement.length = 0;
    interviewMarksData.length = 0;
    interviewMarkStatement.length = 0;
    setInterviewMarksData([]);
  };

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton()
    } else {

      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getMainsAdvertisements(selectedValue));
      if (getMainsAdvertisement) {
        getMainsAdvertisement.length = 0
      }
      if (examList) {
        examList.length = 0;
      }
      setInterviewMarksData([])
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
    }
  };

  const onSubmit = () => {
    dispatch(getInterviewMarkStatementByExamId(selectedExam));
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {

    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + interviewMarkStatement.examName + '</h5><h5>' + label.InterviewMarksReport + '</h5></div>';
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;
    const examName = interviewMarkStatement.examName;

    const options = {
      margin: [1, 0.3, 0.5, 0.3],
      filename: "interviewMarkStatement.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth - 0.2;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = interviewMarkStatement.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`interviewMarkStatement_${examName}.pdf`);
      });
  };

  const downloadPdf = () => {
    genPdf();
    setReloadItem(!reloadItem);
  };

  const handleEditButtonClick = () => {
    setEditMode(true);
  };

  const handleConfirmButtonClick = () => {

    dispatch(interviewMarksApprovalRequest(selectedExam, editedValues));
    onCancelButton();
    setEditMode(false);

  };

  const handleInputChange = (tokenNo, marks, centerName) => {
    setEditedValues(prevValues => {
      let updatedInterviewMarkStatement = prevValues.interviewMarkStatement.map(item => {
        if (item.centerName === centerName) {
          const updatedInterviewData = item.interviewData.map(data => {
            if (data.tokenNo === tokenNo) {
              return { ...data, marks: marks };
            }
            return data;
          });

          return { ...item, interviewData: updatedInterviewData };
        }
        return item;
      });

      const isCenterNameExist = updatedInterviewMarkStatement.some(item => item.centerName === centerName);

      if (!isCenterNameExist) {
        updatedInterviewMarkStatement.push({
          centerName: centerName,
          interviewData: [
            ...prevValues.interviewMarkStatement.find(item => item.centerName === centerName)?.interviewData || [],
            {
              tokenNo: tokenNo,
              marks: marks
            }
          ]
        });
      } else {

        const existingCenter = updatedInterviewMarkStatement.find(item => item.centerName === centerName);
        const existingToken = existingCenter?.interviewData.find(data => data.tokenNo === tokenNo);

        if (!existingToken) {
          existingCenter.interviewData.push({
            tokenNo: tokenNo,
            marks: marks
          });
        }
      }

      return { ...prevValues, interviewMarkStatement: updatedInterviewMarkStatement };
    });
  };

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };

  return (
    <div className="dashboardContentArea">
      <h5 className="ml-3"> {label.interviewMarks} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {headerField &&
            headerField.map((ele, index) => (
              <li className="nav-item" key={ele.id}>
                <a
                  href="#"
                  className={
                    stepName === ele.id
                      ? "nav-link active"
                      : "nav-link bg-profile-tabs"
                  }
                  value="home"
                  id="home-tab"
                  onClick={() => setName(ele.id)}
                  data-toggle="tab"
                  role="tab"
                  aria-controls="home"
                  aria-selected="false"
                >
                  <span>{ele.name}</span>
                </a>
              </li>
            ))}
          <div className="ml-auto">
            <button
              type="reset"
              className="btn btn-primary import-button"
              onClick={() => setShowImportMarks(true)}
            >
              {commonLabels.BUTTON_IMPORT_MARKS}
            </button>
          </div>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "1"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {allUnapprovalEntityList &&
              allUnapprovalEntityList.entityApprovalDtoList &&
              allUnapprovalEntityList.entityApprovalDtoList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}>
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {allUnapprovalEntityList &&
                      allUnapprovalEntityList.entityApprovalDtoList &&
                      allUnapprovalEntityList.entityApprovalDtoList.length >
                      0 &&
                      allUnapprovalEntityList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounter_unapproval++}
                              </td>
                              <td className="word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className=" width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className=" word-break width-15">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>

                              <td className="w-10 word-break  width-20">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam.name}{" "}
                                <br />{" "}
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.exam.nameDvng}
                              </td>
                              <td >
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>

                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.firstName
                                }{" "}
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.lastName
                                }
                              </td>

                              <td className="word-break width-10">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-15">
                                {(session.roleName == 'superadmin' || session.roleName == 'desk officer') &&
                                  <button
                                    type="button"
                                    className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                    onClick={() => {
                                      handleApprovalUser(ele);
                                    }}
                                  >
                                    {commonLabels.REVIEW}
                                  </button>}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_answerkey_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={allUnapprovalEntityList.totalNoOfRecords}
                />
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>

          <div
            className={
              stepName === "2"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group importFromSection">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          // ref={register({ required: true })}
                          value={selectedYear}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList
                              .map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                        </select>
                        {_.get("selectedYear.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                      <div className="form-group col-md-5">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {getMainsAdvertisement &&
                            getMainsAdvertisement.length > 0 &&
                            getMainsAdvertisement
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {
                            examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))
                          }
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                    </div>

                    {/* <div className="row">
                      <div className="form-group col-md-8">
                        {(session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') &&
                          <>    <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>

                            <button
                              type="submit"
                              className="btn btn-primary mr-2"
                              disabled={saveButtonFlag}
                              onClick={handleSubmit((e) => {
                                onSubmit(e);
                                setConfirmClicked(true);
                              })}
                            >
                              {commonLabels.BUTTON_VIEW}
                            </button></>
                        }
                        {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={printFlag || !confirmClicked}
                          onClick={() => {
                            downloadPdf();
                          }}
                        >
                          {commonLabels.BUTTON_PRINT}
                        </button>}

                      </div>
                    </div> */}
                    <div className="row">
                      <div className="form-group col-md-8">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag || editMode || !interviewMarksData || interviewMarksData.length === 0}
                          onClick={handleEditButtonClick}
                        >
                          {commonLabels.BUTTON_EDIT}
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag || !editMode}
                          onClick={handleConfirmButtonClick}
                        >
                          {commonLabels.BUTTON_CONFIRM}
                        </button>

                        {(session.roleName == 'superadmin' || session.roleName == 'secretary') &&
                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            disabled={saveButtonFlag || editMode || !interviewMarksData || interviewMarksData.length === 0}
                            onClick={() => {
                              downloadPdf();
                            }}
                          >
                            {commonLabels.BUTTON_PRINT}
                          </button>}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {selectedExam && interviewMarksData && interviewMarksData.length > 0 && (
              <div ref={pdfRef} className="answerKeyTable" id="InterviewReport">


                {interviewMarkStatement.interviewMarkStatement.map((center, index) => (
                  <div key={index}>
                    <h4>{center.centerName}</h4>
                    <table className="table text-center">
                      <thead>
                        <tr>
                          {[...Array(4)].map((_, i) => (
                            <React.Fragment key={i}>
                              <th id="topbotborder">{label.TokenNo}</th>
                              <th id="topbotborder">{label.Marks}</th>
                              <td id="borderless"></td>
                            </React.Fragment>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(Math.ceil(center.interviewData.length / 4))].map((_, rowIndex) => (
                          <tr key={rowIndex}>
                            {[0, 1, 2, 3].map((colIndex) => {
                              const tokenIndex = rowIndex + colIndex * Math.ceil(center.interviewData.length / 4);
                              const tokenData = center.interviewData[tokenIndex];

                              return (
                                <React.Fragment key={colIndex}>
                                  <td id="bottomborder">{tokenData ? tokenData.tokenNo : '-'}</td>
                                  <td id="bottomborder">
                                    {editMode && tokenData && tokenData.marks && tokenData.tokenNo ? (
                                      <input
                                        type="text"
                                        defaultValue={tokenData && tokenData.marks}

                                        onChange={e => handleInputChange(tokenData.tokenNo, e.target.value, center.centerName, tokenData)}
                                        className={editMode ? "editable-input-box" : "input-box"}
                                      />
                                    ) : (

                                      <span>{tokenData ? tokenData.marks : '-'}</span>
                                    )}
                                  </td>
                                  <td id="borderless"></td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <hr className="mar_top_bottom_8" />
                  </div>
                ))}
              </div>
            )}
          </div>
          {approvalEntityModal && (
            <InterviewReportApprovalEntity
              showModal={approvalEntityModal}
              setShowModal={setApprovalEntityModal}
              setSelectedApprovalEntity={selectedApprovalEntity}
            />
          )}
          <ImportInterviewMarks
            showImportMarks={showImportMarks}
            setShowImportMarks={setShowImportMarks}
            onCancelButton={onCancelButton}
          />
        </div>
      </div>

    </div>
  );
};

export default InterviewReport;
